import useApiMutation from './useApiMutation'
import * as api from '../api'
import useInvalidate from '../useInvalidate'

export type CreateLearningPathArgs = {
  status: string
  title: string
  description: string
  categories?: string[]
  createCertificate: boolean
  certificateValidUntil: Date | null | undefined
  image: string | null
  courses?: string[]
}

export default function useCreateLearningPath() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (data: CreateLearningPathArgs) => {
      const result = api.post('learning-path', data)

      invalidate.courses()

      return result
    },
  })
}
